import React, { useState, useEffect } from "react";
import axios from "axios";
import Head from "../components/Head";
import Foot from "../components/Foot";

const apiUrl = process.env.REACT_APP_API_URL;

function PressMedia() {
  const [pressData, setPressData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPressMedia = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/public/press-media`);
        if (response.data.success) {
          setPressData(response.data.pressMedia);
        }
      } catch (err) {
        console.error("Error fetching press & media:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchPressMedia();
  }, []);

  return (
    <>
      <Head />

      {/* Breadcrumb Section */}
      <section className="ak-about-hero-1">
        <img
          src="assets/img/bg/blog.png"
          className="about-hero-bg ak-bg object-cover"
          alt="..."
        />
        <div className="container">
          <div className="about-hero-content">
            <div className="ak-section-heading ak-style-1">
              <p className="ak-section-subtitle" style={{ color: "white" }}>
                Press & Media
              </p>
              <h2 className="ak-section-title" style={{ color: "white" }}>
                Press & Media
              </h2>
            </div>
            <a href="/" className="back-btn" style={{ color: "white" }}>
              Home / Press & Media
            </a>
          </div>
        </div>
      </section>

      {/* Press Content */}
      <section className="container">
        <div className="ak-height-60 ak-height-lg-50" />

        <div className="row">
          <div className="col-lg-12">
            <div className="blog-content-page">
              {loading ? (
                <p>Loading...</p>
              ) : pressData.length === 0 ? (
                <p>No press coverage available yet.</p>
              ) : (
                pressData.map((item) => (
                  <a
                    href={item.link || "#"}
                    key={item.id}
                    className="blog-card style-2 d-flex align-items-center"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {/* LEFT IMAGE */}
                    <div
                      className="blog-img"
                      style={{ flex: "0 0 300px", marginRight: "20px" }}
                    >
                      <img
                        src={item.imagepath ? `${apiUrl}/${item.imagepath}` : "assets/img/bg/blog.png"}
                        alt={item.title}
                      />
                    </div>

                    {/* RIGHT CONTENT */}
                    <div className="blog-card-info flex-grow-1">
                      <div className="blog-meta-info">
                        <div className="blog-meta">
                          <span className="blog-author">
                            Media /{" "}
                            {item.media}
                          </span>
                        </div>
                        <h5 className="blog-title">{item.title}</h5>
                      </div>

                      <div className="more-btn" style={{ justifyContent: "flex-end", marginTop: "15px" }}>
                        <span>Read Coverage</span>
                        <span className="svg-icon" style={{ marginLeft: "8px" }}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={18}
                            height={19}
                            viewBox="0 0 18 19"
                            fill="none"
                          >
                            <path
                              d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                              stroke="#030917"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>

                    <div className="bottom-border" />
                  </a>
                ))
              )}

              <div className="ak-height-60 ak-height-lg-50" />
            </div>
          </div>
        </div>
      </section>

      <Foot />
    </>
  );
}

export default PressMedia;
